import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AccountService } from '@infodocs/shared/services/account.service';

@Injectable({
	providedIn: 'root',
})
export class SubscriptionPortfolioGuard implements CanActivate {
	private readonly accountService = inject(AccountService);
	private readonly router = inject(Router);

	canActivate(): boolean | UrlTree {
		if (this.accountService.isFree()) {
			return this.router.createUrlTree(['/portfolio', 'company']);
		}

		return true;
	}
}
